import { getOptionValue } from './get-option-value'
import { type AutocompleteOption } from '../model'

export const isOptionEqualToValue = <Value = AutocompleteOption<string>>(option: Value, val: Value) => {
  const optionValue = getOptionValue<Value>(option)
  return Array.isArray(val) ? val.includes(optionValue) : optionValue === getOptionValue<Value>(val)
}
